import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { PerInfoBox } from '../../components/custom_components/InfoBox'
import { InfoBoxTile } from '../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import PerText from '../../components/custom_components/Text'
import useCompaniesManagerOfOrResponsibleOf from '../../graphql/company/hooks/useCompaniesManagerOfOrResponsibleOf'
import { useCollapse } from '../../routes/collapse-context'
import { AllCompaniesSettingsContent } from './AllCompaniesSettingsContent'
import { AllCompaniesSettingsHeader } from './AllCompaniesSettingsHeader'
import { useCompanySettingsStore } from './CompanySettingsStore'
import './index.less'
import { useAuth } from '../../context/auth-context'
import { RoleName } from '../../types'

export const AllCompaniesSettingsView: FC = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const collapsed = useCollapse()
  const [initStore, storeInitialized] = useCompanySettingsStore((state) => [state.initStore, state.storeInitialized])
  const { data, error, loading } = useCompaniesManagerOfOrResponsibleOf(true)

  useEffect(() => {
    if (!!data && !!data.findCompaniesAndCountriesByManagerOrResponsible && !!data.findCompaniesAndCountriesByManagerOrResponsible.length) {
      initStore(data.findCompaniesAndCountriesByManagerOrResponsible)
    }
  }, [data, initStore])

  if (
    !user.roles ||
    user.roles.length === 0 ||
    !user.roles.includes(RoleName.Hr) ||
    loading ||
    error ||
    !data ||
    !data.findCompaniesAndCountriesByManagerOrResponsible ||
    (!!data.findCompaniesAndCountriesByManagerOrResponsible.length && !storeInitialized)
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data || !data.findCompaniesAndCountriesByManagerOrResponsible}
          error={error}
          isPermissionDenied={!error && (!user.roles || user.roles.length === 0 || !user.roles.includes(RoleName.Hr))}
          showSpinner
        />
      </ContentContainer>
    )
  } else if (!!data && data.findCompaniesAndCountriesByManagerOrResponsible.length === 0) {
    return (
      <PerInfoBox>
        <InfoBoxTile
          heading={t('companySettingsView.empty.heading')}
          headingAlign="center"
          contentAlign="center"
          headingColor="secondary"
          headingMt="xl"
        >
          <PerText>{t('companySettingsView.empty.message')}</PerText>
        </InfoBoxTile>
      </PerInfoBox>
    )
  }

  return (
    <ContentContainer collapsed={collapsed}>
      <AllCompaniesSettingsHeader />
      <AllCompaniesSettingsContent />
    </ContentContainer>
  )
}
